export default __webpack_public_path__ + "images/bathroom-heat-3.b4bd3be8d4b04ab7a8fbf2bf7e773b95.png";